// biome-ignore lint/style/noRestrictedImports: encapsulation
import { times as times_ } from "remeda";

import { unpurry } from "./_unpurry";

type UncountedTimes = <T>(count: number, fn: (index: number) => T) => Array<T>;

export const times: typeof times_ & UncountedTimes = unpurry(times_, 2);
